import {SmartComponentManager} from "smart-component-js";
import FormCtrl from "./controllers/FormCtrl";
import DefaultCtrl from "./controllers/DefaultCtrl";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import VisualParallaxComponent from "./components/VisualParallaxComponent";
import AreaPersonaleCtrl from "./controllers/AreaPersonaleCtrl"
import CompletaDatiCtrl from "./controllers/CompletaDatiCtrl"
import HaiVintoCtrl from "./controllers/HaiVintoCtrl"
import AssociaNumeroCtrl from "./controllers/AssociaNumeroCtrl"
import $ from "jquery";
import '../less/mb-fette.less';


SmartComponentManager.registerComponents({
    DefaultCtrl,
    VisualParallaxComponent,
    FeedbackModalComponent,
    FormCtrl,
    AreaPersonaleCtrl,
    CompletaDatiCtrl,
    HaiVintoCtrl,
    AssociaNumeroCtrl

});

$(document).ready(() => {
    let $body = $('.mb-promo-fette-2019');
    SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
});
